import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-cmstransaction-reply-report",
  templateUrl: "./cmstransaction-reply-report.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CMSTransactionReplyReportComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerMemberManagementDashboardType.CMS_Transaction_Reply_Report;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME2];
}

